import TestIdentityProviderConnection from '@Application/Security/Sso/Commands/TestIdentityProviderConnection';
import testIdentityProviderConnection from '@Application/Security/Sso/testIdentityProviderConnection';
import ignoreHandledError from '@UI/Helpers/ignoreHandledError';
import * as React from 'react';
import { useDispatch } from '@verclam/synapse';
import { Button } from '@verclam/ui-kit';

type Props = {
	readonly accountId: number;
};

/** Triggers a connection test for the current configuration, dispatching it and tracking its own
 * loading state. */
const TestConnectionButton: React.FC<Props> = ({ accountId }) => {
	const dispatch = useDispatch();
	const [isTesting, setIsTesting] = React.useState(false);

	const handleTestConnection = React.useCallback(() => {
		setIsTesting(true);

		dispatch(testIdentityProviderConnection(new TestIdentityProviderConnection(accountId)))
			.catch(ignoreHandledError)
			.finally(() => setIsTesting(false));
	}, [accountId, dispatch]);

	return (
		<Button
			type="button"
			outlined
			label="Tester la connexion"
			loading={isTesting}
			onClick={handleTestConnection}
		/>
	);
};

export default TestConnectionButton;
